import { Component, Inject, NgModule } from '@angular/core';
import { SiteSelectorService } from './site-selector.service';
import { SiteBrowserState } from '../../core/util/site-browser.state';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from 'primeng/components/autocomplete/autocomplete';
import { InputTextModule } from 'primeng/components/inputtext/inputtext';
import { FormsModule } from '@angular/forms';
var SiteSelectorComponent = (function () {
    function SiteSelectorComponent(updateService, siteSelectorService) {
        this.updateService = updateService;
        this.siteSelectorService = siteSelectorService;
        this.host = updateService.getSelectedSite();
    }
    /**
     * Is called when a site is selected in the dropdown
     * @param event
     */
    SiteSelectorComponent.prototype.siteSelected = function (event) {
        this.updateService.changeSite(this.host);
    };
    /**
     * Is called as the user tyoes in the filtering select
     * @param event
     */
    SiteSelectorComponent.prototype.filterHosts = function (event) {
        var _this = this;
        this.siteSelectorService.filterForSites(event.query)
            .subscribe(function (sites) { return _this.handleSiteResults(sites, event); });
        setTimeout(function () { }, 100);
    };
    /**
     * Is called when the user clicks to view all sites in the dropdown
     */
    SiteSelectorComponent.prototype.handleDropdownClick = function () {
        var _this = this;
        this.filteredHosts = [];
        this.siteSelectorService.getSites()
            .subscribe(function (sites) { return _this.handleSiteResults(sites); });
        setTimeout(function () { }, 100);
    };
    SiteSelectorComponent.prototype.handleSiteResults = function (hosts, event) {
        if (event === void 0) { event = 0; }
        this.filteredHosts = [];
        this.sites = hosts;
        for (var i = 0; i < this.sites.length; i++) {
            var site = this.sites[i];
            if (event && site.hostname.toLowerCase().indexOf(event.query.toLowerCase()) === 0) {
                this.filteredHosts.push(site);
            }
            else {
                this.filteredHosts[i] = this.sites[i];
            }
        }
    };
    return SiteSelectorComponent;
}());
export { SiteSelectorComponent };
SiteSelectorComponent.decorators = [
    { type: Inject, args: ['updateService',] },
    { type: Component, args: [{
                selector: 'site-selector',
                styles: [require('./../app.css')],
                template: "<div>\n        <p-autoComplete [(ngModel)]=\"host\" [suggestions]=\"filteredHosts\" (completeMethod)=\"filterHosts($event)\"\n                        [size]=\"30\"\n                        [minLength]=\"1\" placeholder=\"Hint: type 'd'\" [dropdown]=\"true\"\n                        (onDropdownClick)=\"handleDropdownClick($event)\"\n                        (onSelect)=\"siteSelected($event)\" field=\"hostname\">\n            <ng-template let-host pTemplate=\"item\">\n                <div class=\"ui-helper-clearfix\" style=\"border-bottom:1px solid #D5D5D5\">\n                    <div style=\"font-size:18px;float:right;margin:10px 10px 0 0\">{{host.hostname}}</div>\n                </div>\n            </ng-template>\n        </p-autoComplete>\n    </div>"
            },] },
];
/** @nocollapse */
SiteSelectorComponent.ctorParameters = function () { return [
    { type: SiteBrowserState, },
    { type: SiteSelectorService, },
]; };
var DotSiteSelectorModule = (function () {
    function DotSiteSelectorModule() {
    }
    return DotSiteSelectorModule;
}());
export { DotSiteSelectorModule };
DotSiteSelectorModule.decorators = [
    { type: NgModule, args: [{
                declarations: [SiteSelectorComponent],
                exports: [SiteSelectorComponent],
                imports: [CommonModule, FormsModule, InputTextModule, AutoCompleteModule],
                providers: [SiteSelectorService]
            },] },
];
/** @nocollapse */
DotSiteSelectorModule.ctorParameters = function () { return []; };
//# sourceMappingURL=site-selector.component.js.map